import * as common from 'store/modules/common'
import { api } from './api'

export const prefix = 'temporary'

export { api }
export const initialState = { 
  deletingBottles: false
}
export const actionTypes = { 
  deleteBottles: `${prefix}/deleteBottles`
}
export const actionCreators = { 
  deleteAllBottles: () => ({
    type: actionTypes.deleteBottles,
    payload: () => api.deleteAllBottles()
  })
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.deleteBottles}${common.suffix.fetching}`: return { ...state, deletingBottles: true }
    case `${actionTypes.deleteBottles}${common.suffix.fetched}`: return { ...state, deletingBottles: false }
    case `${actionTypes.deleteBottles}${common.suffix.rejected}`: return { ...state, deletingBottles: false }

    default: return common.reducer(state, action, prefix)
  }
}

